import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'departures',
    pathMatch: 'full',
  },
  {
    path: 'departures',
    loadComponent: () =>
      import('./features/departures-page/views/pages/departures-page.component').then(
        ({ DeparturesPageComponent }) => DeparturesPageComponent,
      ),
    canMatch: [authGuard],
  },
  {
    path: 'departure-history',
    loadComponent: () =>
      import('./features/departure-history-page/views/pages/departure-history-page.component').then(
        ({ DepartureHistoryPageComponent }) => DepartureHistoryPageComponent,
      ),
    canMatch: [authGuard],
  },
  {
    path: 'team-shift-changes-history',
    loadComponent: () =>
      import(
        './features/team-shift-changes-history-page/views/pages/team-shift-changes-history-page.component'
      ).then(({ TeamShiftChangesHistoryPageComponent }) => TeamShiftChangesHistoryPageComponent),
    canMatch: [authGuard],
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/authorization-page/authorization-page.component').then(
        ({ AuthorizationPageComponent }) => AuthorizationPageComponent,
      ),
  },
  {
    path: 'teams-summary',
    loadComponent: () =>
      import('./features/teams-summary-page/teams-summary-page.component').then(
        ({ TeamsSummaryPageComponent }) => TeamsSummaryPageComponent,
      ),
    canMatch: [authGuard],
  },
  {
    path: 'statistics',
    loadComponent: () =>
      import('./features/statistics/statistics.component').then(
        ({ StatisticsComponent }) => StatisticsComponent,
      ),
    canMatch: [authGuard],
  },
  {
    path: 'missions',
    loadComponent: () =>
      import('./features/missions-page/missions-page.component').then(
        ({ MissionsPageComponent }) => MissionsPageComponent,
      ),
    canMatch: [authGuard],
  },
  {
    path: 'mission-history',
    loadComponent: () =>
      import('./features/mission-history-page/mission-history-page.component').then(
        ({ MissionHistoryPageComponent }) => MissionHistoryPageComponent,
      ),
    canMatch: [authGuard],
  },
  {
    path: 'mission-configurator',
    loadComponent: () =>
      import('./features/missions-configurator/missions-configurator.component').then(
        ({ MissionsConfiguratorComponent }) => MissionsConfiguratorComponent,
      ),
    canMatch: [authGuard],
  },
  {
    path: 'mission-statistics',
    loadComponent: () =>
      import('./features/mission-statistics-page/mission-statistics-page.component').then(
        ({ MissionStatisticsPageComponent }) => MissionStatisticsPageComponent,
      ),
    canMatch: [authGuard],
  },
];
